<template>
  <b-col class="wrap-card-search-page">
    <b-row>
      <b-col v-for="(data,key) in categorisDataSearch.data" :key="key" cols="12" sm="6" lg="4" class="card-item-search-page">
        
        <Card
          :id="data.id"
          :price="data.price"
          :urlImage="data.url_feature_image"
          :title="data.title"
          :province="data.province.name"
          :district="data.district.name"
          :listingPremium="data.listing_premiums"
          :showGoogleAds="data.showGoogleAds"
          :typeAds="categorySelected"
          :listing_attributes_details="data.listing_attributes_details"
          :url = "data.url"
          :fav = "parseInt(data.fav) == 0 ? false : true"
          :target="'_blank'"
          :agency_profile_image="data.agency_profile_image"
        />
      </b-col>
    </b-row>
    
  </b-col>
</template>

<script>
import Card from '../../components/card';
import { mapGetters, mapActions } from "vuex";
export default {
  name: 'searchGrid',
  components: {
    Card
  },
  data() {
    return {
      randomADSListingDetail: 0
    }
  },
  props:{
    categorySelected:{
      type:String,
      default:''
    }
  }, 
  mounted(){
   
  },
  computed:{
    ...mapGetters("CategoryController",
    [
      "categorisDataSearch"
    ]),
  },
  methods: {
    // _categorisDataSearch(val){
    //    if(val.length > 2){
    //     this.randomADSListingDetail = val[Math.floor(Math.random() * val.length)].id;
    //     }else{
    //       this.randomADSListingDetail = 0;
    //     }
    // }
  },
  watch: {
  
  },
}
</script>
<style lang="scss">
  @import "style";
</style>